export interface PositionViewModel {
	id: number;
	key: string;
	lat: number;
	lng: number;
	date: string;
	tooltip: string;
	displayFields: Record<string, string | null>;
	address: string;
	markerType: MapMarkerType;
	links: Link[];
}

export interface RetailLocationViewModel extends PositionViewModel {
	stateId: number;
	companyDivisionId: number;
	companyRegionId: number;
	companyMarketId: number;
	statusId: number;
	partnerId: number;
	partnerTypeId: number;
	active: boolean;
}

export interface BranchViewModel extends PositionViewModel {
	active: boolean;
	brandId: number;
	marketerId: number;
	channelId: number;
	usStateId: number;
	assignedUserId: number;
}

export interface Link {
	label: string;
	value: string;
	href: string;
}

export enum MapMarkerType {
	Pin,
	Flag,
}

export interface MapSettings {
	mapTypes: string[];
	layeredMapViews: string[];
	canShowPositions: boolean;
	showPositions: boolean;
	canShowLeads: boolean;
	showLeads: boolean;
	canShowSales: boolean;
	showSales: boolean;
	canShowRetailLocations: boolean;
	showRetailLocations: boolean;
	defaultMaxPositions: number;
	maxPositions: number;
}
